module.exports = __webpack_public_path__ + "static/img/back3.ce1791d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page3/back3.png
// module id = jXp0
// module chunks = 0